import { useEffect, useRef } from 'react';

import { ensureFirebaseSession, signOutOfFirebase } from '../api/firebase-session';

/**
 * Keeps the global Firebase Auth session in lockstep with the app session:
 * signs in as soon as a logged-in user is known (login or page reload) and
 * signs out when the user logs out. Mount once per app, where the logged-in
 * user's identity lives (Main.tsx).
 */
export const useFirebaseSession = (identity?: { userId?: string; email?: string; phone?: string }) => {
  const hadUser = useRef(false);
  const userId = identity?.userId;
  const email = identity?.email;
  const phone = identity?.phone;

  useEffect(() => {
    if (userId) {
      hadUser.current = true;
      ensureFirebaseSession({ userId, email, phone });
    } else if (hadUser.current) {
      hadUser.current = false;
      signOutOfFirebase();
    }
  }, [userId, email, phone]);
};
